/**
 * oddit-section-main-product
 * Interactive behaviors: thumbnail gallery, accordion, add-to-cart, cross-sell scroll
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-main-product';

  function initSection(section) {
    initThumbnailGallery(section);
    initAddToCart(section);
    initCrossSellRecommendations(section);
    initCrossSellScroll(section);
    initStickyAddToCart(section);
  }

  /**
   * Thumbnail gallery — clicking a thumbnail swaps the main image
   */
  function initThumbnailGallery(section) {
    var thumbnails = section.querySelectorAll('.oddit-section-main-product__thumbnail');
    var mainImage = section.querySelector('.oddit-section-main-product__main-image-img');
    var prevBtn = section.querySelector('.oddit-section-main-product__gallery-prev');
    var nextBtn = section.querySelector('.oddit-section-main-product__gallery-next');
    if (!mainImage || thumbnails.length === 0) return;

    var activeIndex = 0;

    function goToThumb(index) {
      activeIndex = Math.max(0, Math.min(index, thumbnails.length - 1));
      for (var i = 0; i < thumbnails.length; i++) {
        thumbnails[i].classList.toggle('oddit-section-main-product__thumbnail--active', i === activeIndex);
      }
      var thumbImg = thumbnails[activeIndex].querySelector('.oddit-section-main-product__thumbnail-img');
      if (thumbImg && thumbImg.src) {
        mainImage.src = thumbImg.src;
        mainImage.alt = thumbImg.alt || mainImage.alt;
      }
      updateArrows();
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = activeIndex <= 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= thumbnails.length - 1;
    }

    updateArrows();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goToThumb(activeIndex - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goToThumb(activeIndex + 1); });
    }

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('.oddit-section-main-product__thumbnail');
      if (!thumb) return;
      var index = Array.prototype.indexOf.call(thumbnails, thumb);
      if (index !== -1) goToThumb(index);
    });

    // Swipe gestures on main image for mobile
    var mainImageWrap = section.querySelector('.oddit-section-main-product__main-image');
    if (mainImageWrap) {
      var swipeStartX = 0;

      mainImageWrap.addEventListener('touchstart', function (e) {
        swipeStartX = e.touches[0].clientX;
      }, { passive: true });

      mainImageWrap.addEventListener('touchend', function (e) {
        var dx = swipeStartX - (e.changedTouches[0] ? e.changedTouches[0].clientX : swipeStartX);
        if (Math.abs(dx) > 40) {
          goToThumb(dx > 0 ? activeIndex + 1 : activeIndex - 1);
        }
      }, { passive: true });
    }
  }

  /**
   * Add to cart — delegates to window.OdditCartDrawer
   */
  function initAddToCart(section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn || !window.OdditCartDrawer) return;

      var variantId = Number(btn.getAttribute('data-variant-id'));
      if (!variantId) return;

      var quantity = Number(btn.getAttribute('data-quantity')) || 1;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');

      window.OdditCartDrawer.addToCart(variantId, quantity)
        .then(function () {
          window.OdditCartDrawer.open();
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    });
  }

  /**
   * Cross-sell horizontal scroll — update pagination dots on scroll
   */
  function initCrossSellScroll(section) {
    var grid = section.querySelector('.oddit-section-main-product__cross-sell-grid');
    var dotsContainer = section.querySelector('.oddit-section-main-product__cross-sell-dots');
    var prevBtn = section.querySelector('.oddit-section-main-product__cross-sell-prev');
    var nextBtn = section.querySelector('.oddit-section-main-product__cross-sell-next');
    if (!grid) return;

    // Generate dots based on number of cards
    var cards = grid.querySelectorAll('.oddit-section-main-product__cross-sell-card');
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (var d = 0; d < cards.length; d++) {
        var dot = document.createElement('span');
        dot.className = 'oddit-section-main-product__cross-sell-dot';
        if (d === 0) dot.className += ' oddit-section-main-product__cross-sell-dot--active';
        dotsContainer.appendChild(dot);
      }
    }
    var dots = section.querySelectorAll('.oddit-section-main-product__cross-sell-dot');

    var currentIndex = 0;

    function getCards() {
      return grid.querySelectorAll('.oddit-section-main-product__cross-sell-card');
    }

    function goTo(index) {
      var cards = getCards();
      if (cards.length === 0) return;
      if (index < 0 || index > cards.length - 1) return;
      currentIndex = index;

      var gridGap = parseFloat(getComputedStyle(grid).gap) || 18;
      var step = cards[0].offsetWidth + gridGap;
      var offset = currentIndex * step;

      // Cap offset so last card doesn't scroll past the visible area
      var totalGridWidth = cards.length * cards[0].offsetWidth + (cards.length - 1) * gridGap;
      var visibleContainer = grid.closest('.oddit-section-main-product__cross-sell');
      var visibleWidth = visibleContainer ? visibleContainer.offsetWidth : grid.parentElement.offsetWidth;
      var maxOffset = totalGridWidth - visibleWidth;
      if (maxOffset > 0 && offset > maxOffset) {
        offset = maxOffset;
      }

      grid.style.transform = 'translateX(-' + offset + 'px)';
      updateControls();
    }

    function updateControls() {
      var cards = getCards();
      var currentDots = dotsContainer ? dotsContainer.querySelectorAll('.oddit-section-main-product__cross-sell-dot') : [];
      for (var i = 0; i < currentDots.length; i++) {
        currentDots[i].classList.toggle(
          'oddit-section-main-product__cross-sell-dot--active',
          i === currentIndex
        );
      }
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= cards.length - 1;
    }

    updateControls();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    // Swipe gesture support
    var startX = 0;

    grid.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    grid.addEventListener('touchend', function (e) {
      var dx = startX - (e.changedTouches[0] ? e.changedTouches[0].clientX : startX);
      if (Math.abs(dx) > 40) {
        goTo(dx > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });
  }

  /**
   * Cross-sell recommendations — fetch from Shopify product recommendations API
   */
  function initCrossSellRecommendations(section) {
    var container = section.querySelector('[data-cross-sell-recommendations]');
    if (!container) return;

    var productId = container.getAttribute('data-product-id');
    var limit = container.getAttribute('data-limit') || 4;
    var intent = container.getAttribute('data-intent') || 'related';
    var sectionId = container.getAttribute('data-section-id');

    if (!productId || !sectionId) return;
    if (container.querySelector('.oddit-section-main-product__cross-sell-grid')) return;

    var url =
      window.Shopify.routes.root +
      'recommendations/products?section_id=' +
      sectionId +
      '&product_id=' +
      productId +
      '&limit=' +
      limit +
      '&intent=' +
      intent;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContainer = doc.querySelector('[data-cross-sell-recommendations]');
        if (newContainer && newContainer.innerHTML.trim().length > 0) {
          container.innerHTML = newContainer.innerHTML;
          var reveals = container.querySelectorAll('.oddit-reveal');
          for (var i = 0; i < reveals.length; i++) {
            reveals[i].classList.add('is-visible');
          }
          initCrossSellScroll(section);
        }
      })
      .catch(function (err) {
        console.error('[oddit-section-main-product] Cross-sell recommendations error:', err);
      });
  }

  /**
   * Sticky Add To Cart — show/hide based on main ATC button visibility
   */
  function initStickyAddToCart(section) {
    var stickyBar = section.querySelector('.oddit-section-main-product__sticky-atc');
    if (!stickyBar) return;

    var mainAtcButton = section.querySelector('.oddit-section-main-product__add-to-cart');

    if (mainAtcButton) {
      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              stickyBar.classList.remove('is-visible');
            } else {
              var rect = mainAtcButton.getBoundingClientRect();
              if (rect.bottom < 0) {
                stickyBar.classList.add('is-visible');
              } else {
                stickyBar.classList.remove('is-visible');
              }
            }
          }
        },
        { threshold: 0 }
      );
      observer.observe(mainAtcButton);
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) {
              stickyBar.classList.add('is-visible');
            } else {
              stickyBar.classList.remove('is-visible');
            }
          }
        },
        { threshold: 0 }
      );

      var sentinel = document.querySelector('[data-sticky-cart-sentinel]');
      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.setAttribute('data-sticky-cart-sentinel', '');
        sentinel.style.position = 'absolute';
        sentinel.style.top = '600px';
        sentinel.style.height = '1px';
        sentinel.style.width = '1px';
        sentinel.style.pointerEvents = 'none';
        document.body.appendChild(sentinel);
      }
      observer.observe(sentinel);
    }
  }

  // Initialize all instances
  var sections = document.querySelectorAll(SECTION_SELECTOR);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();